import React, {useEffect, useState} from "react";
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Grid2 from "@mui/material/Grid2";
import Button from "@mui/material/Button";
import ReplayIcon from '@mui/icons-material/Replay';
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {useForm} from "react-hook-form";
import {useAuthToken, useRequestUrl, useShowPasswordDialog, useCurrentUser
} from "../context/contextHooks";
import IconButton from "@mui/material/IconButton";
import sendPost from "../http/sendRequests";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import AlertMessage from "../utils/AlertMessage";
import {useSxStyles as sx} from "../styles/sxStyles";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";


const UpdateUserPassword = () => {

    const [currentUser,] = useCurrentUser();
    const [open, setOpen] = useShowPasswordDialog()
    const { register, handleSubmit } = useForm();
    const [authToken,] = useAuthToken();
    const [requestUrl,] = useRequestUrl();
    const [showPasswordCurrent, setShowPasswordCurrent] = useState(false);
    const [showPasswordNew, setShowPasswordNew] = useState(false);
    const [showPasswordNewVerify, setShowPasswordNewVerify] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [passwordChangeMessage, setPasswordChangeMessage] = useState({ success: false, message: '' })
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (open) {
            setErrorMessage(null);
            setPasswordChangeMessage({ success: false, message: '' })
            setShowPasswordCurrent(false);
            setShowPasswordNew(false);
            setShowPasswordNewVerify(false);
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, [open])

    const handleClose = () => {
        setErrorMessage(null);
        setPasswordChangeMessage({ success: false, message: '' })
        setOpen(false);
    }

    const togglePasswordCurrent = () => {
        setShowPasswordCurrent(!showPasswordCurrent);
    }

    const togglePasswordNew = () => {
        setShowPasswordNew(!showPasswordNew);
    }

    const togglePasswordNewVerify = () => {
        setShowPasswordNewVerify(!showPasswordNewVerify);
    }

    const disableMouseDown = (e) => {
        e.preventDefault();
    }

    const saveUser = (formRequest) => {
        setPasswordChangeMessage({ success: false, message: '' })
        let strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*+])(?=.{12,20})");
        if (!formRequest.currentPassword) {
            setErrorMessage('Please enter Current Password');
        } else if (!formRequest.newPassword ) {
            setErrorMessage('Please enter New Password');
        } else if (!formRequest.newPasswordVerify) {
            setErrorMessage('Please Re-enter New Password');
        } else if (formRequest.newPassword !== formRequest.newPasswordVerify) {
            setErrorMessage('Re-enter password must match New Password');
        } else if (formRequest.currentPassword === formRequest.newPassword) {
            setErrorMessage('New password can not be the same as old password');
        } else if (!strongRegex.test(formRequest.newPassword)) {
            setErrorMessage('New password must contain 1 lowercase, 1 uppercase, 1 numeric, and 1 special character and must be between 12 and 20 characters long');
        } else {
            setLoading(true);
            const request = { "username": currentUser.username, "currentPassword": formRequest.currentPassword, "newPassword": formRequest.newPassword }
            const url = `${requestUrl}/passwordChange`
            sendPost(url, request, `Bearer ${authToken}`, setPasswordChangeMessage, setErrorMessage, setLoading)
        }
    }

    return <>
        <form autoComplete="off">
        {open ?
            <Dialog
                disableEscapeKeyDown
                fullWidth
                id="changePasswordDialog"
                maxWidth='sm'
                open={open}
                onClose={handleClose}
                sx={sx.dialog}
            >
                <DialogTitle style={{paddingBottom: '1rem'}}>
                    <Typography variant="h5" color='primary'>
                        Change Password
                    </Typography>
                </DialogTitle>
                <Backdrop sx={sx.backdrop} open={loading}>
                    <CircularProgress color="inherit" />
                </Backdrop>

                    <DialogContent style={{marginTop: '0', paddingTop: '0', paddingRight: '1rem', paddingLeft: '1rem'}}>
                        <Grid2 container >
                            {!passwordChangeMessage.success && (errorMessage || passwordChangeMessage.message) &&
                            <AlertMessage title="Password Change Failed" severity="error" msg={errorMessage ? errorMessage : passwordChangeMessage.message} />
                            }
                            {passwordChangeMessage.success &&
                            <AlertMessage severity="success" msg={passwordChangeMessage.message} />
                            }
                            <FormControl
                                fullWidth
                                style={{ margin: 8, marginTop: 0 }}
                                required
                                {...register('currentPassword')}
                            >
                                <FormLabel shrink={true} htmlFor="current-password" sx={sx.inputLabel}>Current Password</FormLabel>
                                <TextField
                                    id="current-password"
                                    name="currentPassword"
                                    variant='outlined'
                                    type={showPasswordCurrent ? 'text' : 'password'}
                                    autoComplete="new-password"
                                    slotProps={{
                                        input: {
                                            endAdornment: (
                                                <InputAdornment position='end'>
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={togglePasswordCurrent}
                                                        onMouseDown={disableMouseDown}
                                                        size="large">
                                                        { showPasswordCurrent ? <Visibility/> : <VisibilityOff/> }
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        },

                                        htmlInput: {sx: sx.textbox}
                                    }} />
                            </FormControl>
                            <FormControl
                                fullWidth
                                style={{ margin: 8, marginTop: 0 }}
                                required
                                {...register('newPassword')}
                            >
                                <FormLabel htmlFor="new-password" sx={sx.inputLabel}>New Password</FormLabel>
                                <TextField
                                    id="new-password"
                                    name="newPassword"
                                    variant='outlined'
                                    type={showPasswordNew ? 'text' : 'password'}
                                    autoComplete="off"
                                    slotProps={{
                                        input: {
                                            endAdornment: (
                                                <InputAdornment position='end'>
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={togglePasswordNew}
                                                        onMouseDown={disableMouseDown}
                                                        size="large">
                                                        { showPasswordNew ? <Visibility/> : <VisibilityOff/> }
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        },

                                        htmlInput: {sx: sx.textbox}
                                    }} />
                            </FormControl>
                            <FormControl
                                fullWidth
                                style={{ margin: 8, marginTop: 0 }}
                                required
                                {...register('newPasswordVerify')}>
                                <FormLabel htmlFor="new-password-verify" sx={sx.inputLabel}>Re-enter New Password</FormLabel>
                                <TextField
                                    id="new-password-verify"
                                    name="newPasswordVerify"
                                    variant='outlined'
                                    type={showPasswordNewVerify ? 'text' : 'password'}
                                    autoComplete="off"
                                    slotProps={{
                                        input: {
                                            endAdornment: (
                                                <InputAdornment position='end'>
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={togglePasswordNewVerify}
                                                        onMouseDown={disableMouseDown}
                                                        size="large">
                                                        { showPasswordNewVerify ? <Visibility/> : <VisibilityOff/> }
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        },

                                        htmlInput: {sx: sx.textbox}
                                    }} />
                            </FormControl>
                        </Grid2>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined"
                                color="primary"
                                startIcon={<ReplayIcon/>}
                               sx={sx.button}
                                onClick={handleClose}
                        >
                            {passwordChangeMessage.success ? 'Close' : 'Cancel'}
                        </Button>
                        {passwordChangeMessage.success ?
                            null
                            : <Button variant="contained"
                                      color="primary"
                                      startIcon={<SaveAltIcon/>}
                                      sx={sx.button}
                                      onClick={handleSubmit(saveUser)}
                            >
                                Save
                            </Button>}
                    </DialogActions>
            </Dialog>
            :
            null
        }
        </form>
    </>;
};

export default UpdateUserPassword;
